import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const removeAssetFromCategory = (category, asset) => request.put(`${API_BASE_URL}/blockchain/category/${category}/assets/${asset}/remove`)

export default removeAssetFromCategory